
import consola from 'consola'


const Logger = () => {

    const _logger = consola
    const date = new Date()
    _logger.level = 5

    function _info(message, tag) {
        _logger.info({ message, tag, date })
    }
    function _error(message, tag) {
        _logger.error({ message, tag, date })
    }
    function _success(message, tag) {
        _logger.success({ message, tag })
    }
    function _debug(message, tag) {
        _logger.debug({ message, tag })
    }
    function _trace(message, tag) {
        _logger.trace({ message, tag })
    }
    function _warn(message, tag) {
        consola.warn({ message, tag, date: "Asa" })
    }
    function _fatal(message, tag) {
        _logger.fatal({ message, tag })
    }
    function _ready(message, tag) {
        _logger.ready({ message, tag })
    }
    return {
        info: (message, tag) => _info(message, tag),
        error: (message, tag) => _error(message, tag),
        success: (message, tag) => _success(message, tag),
        debug: (message, tag) => _debug(message, tag),
        trace: (message, tag) => _trace(message, tag),
        warn: (message, tag) => _warn(message, tag),
        fatal: (message, tag) => _fatal(message, tag),
        ready: (message, tag) => _ready(message, tag)
    }
}
// new instance of logger (singleton)
export const appLogger = Logger()

